import { render, staticRenderFns } from "./old-reqs.vue?vue&type=template&id=45f516fa&scoped=true"
import script from "./old-reqs.vue?vue&type=script&lang=js"
export * from "./old-reqs.vue?vue&type=script&lang=js"
import style0 from "./old-reqs.vue?vue&type=style&index=0&id=45f516fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f516fa",
  null
  
)

export default component.exports